<template>
  <div class="edit">
    <el-form
      :model="user"
      label-position="top"
      :rules="rules"
      ref="userEditForm"
      :disabled="loading">
      <el-form-item :label="$t('name')" prop="name">
        <el-input v-model="user.name" />
      </el-form-item>
      <el-form-item :label="$t('email')">
        <el-input
          v-model="user.email"
          class="ltr tahoma text-right"
          />
      </el-form-item>
      <el-form-item :label="$t('mobile')">
        <el-input
          v-model="user.mobile"
          class="ltr tahoma text-right"
          />
      </el-form-item>
      <div class="line"></div>
      <el-form-item class="no-margin">
        <el-button
         type="primary"
         @click="submitForm('userEditForm')"
         :loading="loading">
          {{ $t('submit') }}
        </el-button>
        <el-button
         @click="$emit('close-clicked')"
         :loading="loading">
          {{ $t('close') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    user: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    const checkRequired = (rule, value, callback) => {
      const { user } = this
      const { name } = user
      if (name.length === 0) {
        callback(this.$i18n.t('field_required'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      rules: {
        name: [{
          validator: checkRequired,
          trigger: 'blur'
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'domainsPath'
    ])
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    toggleLoading () {
      this.loading = !this.loading
    },
    handleUpdateUserInfoSuccess (res) {
      const message = this.$i18n.t('is_successful', {
        operation: this.$i18n.t('edit_user')
      })
      this.$emit('close-clicked')
      this.$emit('user-updated', res)
      this.$message({
        message,
        type: 'success'
      })
    },
    formatMobileNumber (input) {
      const code = '+98-'
      let formated = input
      if (formated.startsWith('9', 0)) {
        formated = `${code}${formated}`
      }
      if (formated.startsWith('09', 0)) {
        formated = `${code}${formated.substring(1, formated.length)}`
      }
      if (formated.startsWith('0098', 0)) {
        formated = `${code}${formated.substring(4, formated.length)}`
      }
      return formated
    },
    async updateUserInfo () {
      const { user } = this
      const { name, id, mobile, email } = user
      const formatedMobile = this.formatMobileNumber(mobile)

      const params = {
        name
      }
      if (email.length) {
        params.email = email
      }
      if (mobile.length) {
        params.mobile = formatedMobile
      }
      this.toggleLoading()
      await this.handleRequest({
        name: `${this.domainsPath}/users`,
        action: 'update',
        data: {
          id,
          toUpdate: params
        }
      }).then(this.handleUpdateUserInfoSuccess)
        .finally(this.toggleLoading)
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateUserInfo()
        } else {
          return false
        }
      })
    }
  }
}
</script>
